import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { A11y, Autoplay, FreeMode, Keyboard, Navigation, Pagination, Virtual, } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
// eslint-disable-next-line import/no-unassigned-import
import 'swiper/css';
// eslint-disable-next-line import/no-unassigned-import
import 'swiper/css/pagination';
// eslint-disable-next-line import/no-unassigned-import
import 'swiper/css/navigation';
// eslint-disable-next-line import/no-unassigned-import
import 'swiper/css/a11y';
import { HeroStageType } from '../../enums';
import { ControlDiagonalHero } from './ControlDiagonalHero';
import { ControlsBoxHero } from './ControlsBoxHero';
import { ControlsDefault } from './ControlsDefault';
import styles from './Slider.module.scss';
const navigationConfig = {
    nextEl: '#slider-button-next',
    prevEl: '#slider-button-prev',
    lockClass: 'd-none',
};
const paginationConfig = {
    clickable: true,
    el: '#slider-pagination',
    bulletClass: 'sliderBullet',
    bulletActiveClass: 'sliderActiveBullet',
};
const keyboardOptions = {
    enabled: true,
    onlyInViewport: true,
    pageUpDown: false,
};
const Slider = ({ a11yNextSlide, a11yPreviousSlide, autoPlay = false, classes, config, handleShowNext = () => null, handleShowPrevious = () => null, handleSlideClickNext, handleSlideClickPrevious, handleTouchMove, handleTouchStart, heroStageType = HeroStageType.DefaultHero, loop = false, slides, virtualSlide = false, }) => {
    const swiperRef = useRef();
    const [activeSlide, setActiveSlide] = useState(slides[config.initialSlide || 0]);
    const [prevSlideIndex, setPrevSlideIndex] = useState(config.initialSlide || 0);
    const [isAutoPlay, setIsAutoPlay] = useState(false);
    const handleSlideChange = (swiper) => {
        setPrevSlideIndex(swiper.previousIndex);
        setActiveSlide(slides[swiper.realIndex]);
    };
    useEffect(() => {
        const swiperInstance = swiperRef.current;
        if (swiperInstance) {
            const onSlideChangeTransitionEnd = () => {
                if (!isAutoPlay) {
                    if (swiperInstance.activeIndex > prevSlideIndex && handleSlideClickNext) {
                        handleSlideClickNext();
                    }
                    else if (swiperInstance.activeIndex < prevSlideIndex &&
                        handleSlideClickPrevious) {
                        handleSlideClickPrevious();
                    }
                }
                setIsAutoPlay(false);
            };
            const onAutoplay = () => {
                setIsAutoPlay(true);
            };
            swiperInstance.on('slideChangeTransitionEnd', onSlideChangeTransitionEnd);
            swiperInstance.on('autoplay', onAutoplay);
            return () => {
                swiperInstance.off('slideChangeTransitionEnd', onSlideChangeTransitionEnd);
                swiperInstance.off('autoplay', onAutoplay);
            };
        }
        return () => null;
    }, [handleSlideClickNext, handleSlideClickPrevious, isAutoPlay, prevSlideIndex]);
    if (!slides?.length) {
        return null;
    }
    return (_jsxs(Swiper, { modules: [Autoplay, Navigation, Pagination, Keyboard, A11y, Virtual, FreeMode], className: classNames({
            [styles.boxHero]: heroStageType && heroStageType === HeroStageType.BoxHero,
            [styles.diagonalHero]: heroStageType && heroStageType === HeroStageType.DiagonalHero,
        }, classes?.swiperWrapper), spaceBetween: config.spaceBetween, slidesPerView: config.slidesPerView, slidesPerGroup: config.slidesPerGroup, navigation: config.showNavigation && navigationConfig, pagination: config.showPagination && paginationConfig, touchRatio: config.touchRatio, onSlideChange: handleSlideChange, onSlidePrevTransitionStart: handleShowPrevious, onSlideNextTransitionStart: handleShowNext, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, keyboard: keyboardOptions, watchOverflow: true, freeMode: { enabled: true, sticky: true }, a11y: {
            enabled: true,
            prevSlideMessage: a11yPreviousSlide,
            nextSlideMessage: a11yNextSlide,
        }, onSwiper: (swiper) => {
            swiperRef.current = swiper;
        }, initialSlide: config.initialSlide || 0, autoplay: autoPlay, loop: loop, virtual: virtualSlide, children: [slides.map((slide, index) => (_jsx(SwiperSlide, { onFocus: () => {
                    if (swiperRef.current) {
                        // this is to avoid weird behavior when using tab
                        swiperRef.current.el.scrollLeft = 0;
                    }
                }, className: classes?.swiperSlide, virtualIndex: index, children: slide.content }, slide.key))), heroStageType === HeroStageType.DefaultHero &&
                (config.showNavigation || config.showPagination) &&
                (config.slidesPerView < slides?.length ||
                    config.slidesPerGroup < slides?.length) && (_jsx(ControlsDefault, { a11yNextSlide: a11yNextSlide, a11yPreviousSlide: a11yPreviousSlide, config: config, classes: classes })), heroStageType === HeroStageType.BoxHero && (_jsx(ControlsBoxHero, { a11yNextSlide: a11yNextSlide, a11yPreviousSlide: a11yPreviousSlide, config: config, activeSlide: activeSlide })), heroStageType === HeroStageType.DiagonalHero && (_jsx(ControlDiagonalHero, { a11yNextSlide: a11yNextSlide, a11yPreviousSlide: a11yPreviousSlide, config: config, activeSlide: activeSlide }))] }));
};
export { Slider };
